import { StackScreenProps } from '@react-navigation/stack';
import * as React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import ContainedButton from '../components/styled/ContainedButton';
import { RootStackParamList } from '../types/types';
import { useAuthState } from '../auth/authContext';


export default function NotFoundScreen({
  navigation,
}: StackScreenProps<RootStackParamList, 'NotFound'>) {
  const { userType } = useAuthState();
  const isFan = userType === 'fan'
  const route = isFan ? 'Fan' : 'Artist'
  return (
    <View style={styles.container}>
      <Text style={styles.title}>This screen doesn't exist.</Text>
      <ContainedButton
        onPress={() => navigation.replace(route)}
        title='Go to home screen!'
      >
      </ContainedButton>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  linkText: {
    fontSize: 14,
    color: '#2e78b7',
  },
});
